export const itemFields = Object.freeze({
  NAME: 'name',
  START: 'start',
  AFE: 'afe',
  ESTIMATE: 'estimate',
  P90: 'P90',
  ACTUAL: 'actual',
  NPT: 'npt',
  WOW: 'wow',
  VARIANCE: 'variance',
  FINISH: 'finish',
  PLANNED_DEPTH: 'plannedDepth',
  ACTUAL_DEPTH: 'actualDepth',
  SECTION: 'section',
  OPERATION: 'operation',
  ACTIVITY: 'activity',
});
